import { DisplayUser } from "@/stores/types/user-types";

export function getAssignedToText(assignedDisplayUsers: DisplayUser[]) {
  const assignedDisplayNames = assignedDisplayUsers.map((user) => user.display);
  const numberOfAssignees = assignedDisplayNames.length;
  const restNumberOfAssignees = numberOfAssignees - 1;
  const assignedToText = `Assigned to ${assignedDisplayNames[0]}`;

  if (!restNumberOfAssignees) {
    return assignedToText;
  }

  const pluralSuffix = restNumberOfAssignees > 1 ? "s" : "";

  const otherText = restNumberOfAssignees
    ? `and ${restNumberOfAssignees} other${pluralSuffix}`
    : "";

  return `${assignedToText} ${otherText}`;
}
